import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,  FormControl} from 'react-bootstrap';
 import moment   from 'moment'
import {downloadCustomReport} from 'util/Utils';
import json2csv   from 'json2csv'
import config from  '../../../config';

import Select   from 'react-select'
  import {prepareSelectOptionsList,filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';
 const allReportFieldList = [
     {label: 'First name', value:'UserID.firstName'},
     {label: 'Last name', value:'UserID.lastName'},
     {label: 'Email', value:'UserID.email'},
     {label: 'Shopify Customer ID', value:'UserID.ShopifyCustomerID'},
     {label: 'Location', value:'MarketName'},
    {label: 'Payment data', value:'PaymentData'},
    {label: 'Payment method', value:'PaymentMethod'},
    {label: 'Payout', value:'Payout'},
    {label: 'Create date', value:'createdAt'},
     {label: 'PA Street ', value:'PickupAddress.Street'},
     {label: 'PA State ', value:'PickupAddress.State'},
     {label: 'PA City ', value:'PickupAddress.City'},
     {label: 'PA Zip ', value:'PickupAddress.Zip'},

     {label: 'Phone number', value:'PhoneNumber'},
      {label: 'Metro Area', value:'MetroArea'},
     {label: 'Seller number', value:'SellerNumber'},
     {label: 'Seller display name', value:'DisplayName'},
     {label: 'WhiteGlove', value:'Warehouse'},
     {label: 'Is Buyer', value:'BuyerAsWell'},
      {label: '#Services', value:'ServicesTotalNumber'},
     {label: '#Pickups', value:'PickupsTotalNumber'},
     {label: '#Dropoffs', value:'DropoffsTotalNumber'},
     {label: '#Products Listed', value:'ProductsTotalNumber'},
     {label: 'Value of items', value:'ProductsTotalSum'},
     {label: 'Money Made', value:'SellerTotalMade'},
     {label: '#Sale Transactions', value:'SaleTransactionsTotalNumber'},
     {label: 'First Service Date', value:'FirstServiceDate'},
     {label: 'Last Service Date', value:'LastServiceDate'},
     {label: 'Referrals', value:'Referrals'},
]

export default class AdminSellersActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
             pending: false,
            reportFields: allReportFieldList
         };

    };




    downloadReport(){
    // return downloadCustomReport.call(this)
          var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
              overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
         console.log('this.props.adminSellers.selectedRecords', this.props.adminSellers.selectedSellers);
         var queryParams = {'sellers': this.props.adminSellers.selectedSellers, reportType:'sellers' }
        queryParams.addFields =_.intersection(_.map(this.state.reportFields, 'value'),['ServicesTotalNumber','DropoffsTotalNumber','ProductsTotalSum',
            'FirstServiceDate', 'LastServiceDate',   'PickupsTotalNumber', 'ProductsTotalNumber', 'SaleTransactionsTotalNumber', 'SellerTotalMade'])
        this.props.makeRequest(queryParams, methodData).then(res => {
           var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })
            var dataToExport  = _.map(res.data, function (record) {

                if (record.FirstServiceDate){
                    console.log('first service data',record.FirstServiceDate  );
                    record.FirstServiceDate = moment( record.FirstServiceDate).format("YYYY-MM-DD")
                }
                if (record.LastServiceDate){
                    record.LastServiceDate = moment( record.LastServiceDate).format("YYYY-MM-DD")
                }
                if ( record.ServicesTotalNumber ==0){
                    record.ServicesTotalNumber = ''
                }
                if ( record.PickupsTotalNumber ==0){
                    record.PickupsTotalNumber = ''
                }
                if ( record.DropoffsTotalNumber ==0){
                    record.DropoffsTotalNumber = ''
                }
                if ( record.SaleTransactionsTotalNumber ==0){
                    record.SaleTransactionsTotalNumber = ''
                }
                if (_.includes(_.map(fields, 'value'), 'ProductsTotalSum')) {
                    if (record.ProductsTotalSum >= 0) {
                        record.ProductsTotalSum = '$' + record.ProductsTotalSum.toFixed(2)
                    } else {
                        record.ProductsTotalSum = '-$' + Math.abs(record.ProductsTotalSum.toFixed(2))
                    }
                }
                if (_.includes(_.map(fields, 'value'), 'SellerTotalMade')) {
                    if (record.SellerTotalMade >= 0) {
                        record.SellerTotalMade = '$' + record.SellerTotalMade.toFixed(2)
                    } else {
                        record.SellerTotalMade = '-$' + Math.abs(record.SellerTotalMade.toFixed(2))
                    }
                }
                return  record
               // return {...record, ...customData}
            })
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
                unwindPath: 'UserID'
            })

               var filename = "report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }

        }).catch(err => {
            console.log('err', err );
        });
    }
    handleDownloadComplete(){
        console.log(' handleDownloadComplete',true );
        this.setState({'downloadReport':false});
    }
    onSelectTab(event){
         this.setState({displayReportTab:!this.state.displayReportTab})
    }
    render() {
         // if (_.size(self.state.filterOptions.ageGroup) >0 ){
        //     ageRanges.unshift({value: false, label: 'All groups'});
        //  }
        return (
            <div className="action-block">
                <Tabs defaultActiveKey={''} onSelect={(e)=>{this.onSelectTab(e)}} id="sellerActionBox" >
                     <Tab eventKey={'reports'} unmountOnExit={true} title="Reports">
                        <Row className={this.state.displayReportTab ? '' : 'hidden'}>
                            <Col md={4} xs={4} className="top10">
                                <Select
                                    tabIndex="0"
                                    searchable={true}
                                    multi
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Included fields"
                                    options={allReportFieldList}
                                    onChange={ (selectedOptions) => this.setState({'reportFields': selectedOptions})}
                                    //  filterOptions={filterOptions}
                                    value={this.state.reportFields}
                                />
                            </Col>

                        </Row>
                        <Row>

                            <Col md={3} xs={6} className="top10">
                                <button className="btn btn-primary" disabled={this.state.pending}
                                        onClick={ this.downloadReport.bind(this)}
                                        type="button">
                                    Download report
                                </button>


                            </Col>
                        </Row>
                    </Tab>
                    </Tabs>

                </div >
        );

    }
}



